import React from 'react'
import { motion } from "framer-motion";

const SolutionHero = () => {
  return (
   <section className="about-hero">

      <div className="hero-container">

        {/* LEFT */}
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >

          <h2 className="hero_head">
           End-to-end digital solutions to grow your business
          </h2>

          <p className="hero-text">
             High-quality solutions designed to scale your business with
                modern technologies.
          </p>

        </motion.div>

        {/* RIGHT */}
        <div className="hero-right">

           <div className="blob">
            <img className="cover-img"
              src="./sol-hero.webp"
              alt="team"
              loading='lazy'
            />
          </div>

        </div>

      </div>
    </section>
  )
}

export default SolutionHero